export enum NetworkTypeNameEnum {
	ALL = 'TODOS',
	SELF_NETWORK = 'REDE_PROPRIA',
	ACCREDITED_NETWORK = 'REDE_CREDENCIADA',
}
